module.exports = __webpack_public_path__ + "c38f34d594c7f574e0e530c7dce70371.pdf";